class SocialMediaItem {
  constructor(
    _id,
    id,
    platform,
    handle,
    url,
    icon,
    description,
    followers,
    color,
    active
  ) {
    this._id = _id;
    this.id = id;
    this.platform = platform || "";
    this.handle = handle || "";
    this.url = url || "";
    this.icon = icon || "";
    this.description = description || "";
    this.followers = followers || "";
    this.color = color || "";
    this.active = !!active;
  }

  static fromJSON(json = {}) {
    return new SocialMediaItem(
      json._id || json.id || null,
      json.id || json._id || null,
      json.platform || json.name || "",
      json.handle || "",
      json.url || json.link || "",
      json.icon || "",
      json.description || json.summary || "",
      json.followers || "",
      json.color || "",
      !!json.active
    );
  }

  toJSON() {
    return {
      _id: this._id,
      id: this.id,
      platform: this.platform,
      handle: this.handle,
      url: this.url,
      icon: this.icon,
      description: this.description,
      followers: this.followers,
      color: this.color,
      active: this.active,
    };
  }
}

module.exports = SocialMediaItem;
